import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "cfg-overlay"
}
const _hoisted_2 = { class: "cfg-modal" }
const _hoisted_3 = { class: "cfg-header" }
const _hoisted_4 = { class: "cfg-body" }
const _hoisted_5 = { class: "check-grid" }
const _hoisted_6 = ["checked", "onChange"]
const _hoisted_7 = { class: "cfg-seccion" }
const _hoisted_8 = { class: "check-grid" }
const _hoisted_9 = ["checked", "onChange"]
const _hoisted_10 = { class: "cfg-seccion" }
const _hoisted_11 = { class: "cfg-desc" }
const _hoisted_12 = { class: "nueva-col-form" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "extra-cols-lista"
}
const _hoisted_15 = { class: "extra-col-head" }
const _hoisted_16 = ["onUpdate:modelValue"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "extra-filas"
}
const _hoisted_19 = { class: "extra-fila-label" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = {
  key: 1,
  class: "cfg-desc"
}
const _hoisted_22 = {
  key: 1,
  class: "sin-extra"
}
const _hoisted_23 = { class: "cfg-seccion" }
const _hoisted_24 = { class: "check-grid" }
const _hoisted_25 = ["checked", "onChange"]
const _hoisted_26 = { class: "cfg-seccion" }
const _hoisted_27 = { class: "radio-row" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "cfg-seccion" }
const _hoisted_30 = { class: "radio-row" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "cfg-seccion" }
const _hoisted_33 = { class: "radio-row" }
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "cfg-seccion" }
const _hoisted_36 = { class: "radio-row" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "cfg-seccion" }
const _hoisted_39 = { class: "radio-row" }
const _hoisted_40 = { class: "radio-item" }
const _hoisted_41 = { class: "radio-item" }
const _hoisted_42 = { class: "cfg-seccion" }
const _hoisted_43 = { class: "check-grid" }
const _hoisted_44 = ["checked", "onChange"]
const _hoisted_45 = { class: "cfg-seccion" }
const _hoisted_46 = { class: "img-fuente-tabs" }
const _hoisted_47 = {
  key: 0,
  class: "archivo-ok"
}
const _hoisted_48 = {
  key: 1,
  class: "archivo-placeholder"
}
const _hoisted_49 = { class: "cfg-seccion" }
const _hoisted_50 = { class: "cfg-seccion" }
const _hoisted_51 = { class: "cfg-seccion" }
const _hoisted_52 = { class: "radio-row" }
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "cfg-seccion" }
const _hoisted_55 = { class: "cfg-seccion" }
const _hoisted_56 = { class: "import-fuente-row" }
const _hoisted_57 = ["onClick"]
const _hoisted_58 = { class: "import-cols-grid" }
const _hoisted_59 = ["checked", "onChange"]
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "cfg-seccion" }
const _hoisted_62 = { class: "tabla-header-row" }
const _hoisted_63 = { class: "tabla-header-reorder" }
const _hoisted_64 = ["disabled", "onClick"]
const _hoisted_65 = ["disabled", "onClick"]
const _hoisted_66 = ["onUpdate:modelValue"]
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "cfg-seccion" }
const _hoisted_69 = ["onUpdate:modelValue"]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = { class: "cfg-footer" }

import { ref, computed, watch } from 'vue'
import { useGestionResultadosAutoevaluacion } from '@/store/GestionResultadosAutoevaluacion'
import type { NodoResultado, AspectoResultado } from '@/interfaces/ResultadosAutoevaluacion'

type TcFuente = 'factores' | 'caracteristicas' | 'aspectos'

interface BloqueDesc { id: string; tipo: string; params?: Record<string, any> }
interface ExtraColumna { id: string; titulo: string; filas: Record<string, string> }


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfiguradorBloqueModal',
  props: {
    visible: { type: Boolean },
    bloque: {}
  },
  emits: ["cerrar", "guardar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Configuración de un bloque del informe.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */

const props = __props
const emit = __emit

const store = useGestionResultadosAutoevaluacion()

function sortByOrdinal(a: string | null | undefined, b: string | null | undefined): number {
  const ap = (a ?? '').split('.').map(n => parseInt(n, 10) || 0)
  const bp = (b ?? '').split('.').map(n => parseInt(n, 10) || 0)
  for (let i = 0; i < Math.max(ap.length, bp.length); i++) {
    const d = (ap[i] ?? 0) - (bp[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

const factoresStore = computed(() =>
  [...(store.resultados?.factores ?? [])].sort((a, b) => sortByOrdinal(a.ordinal, b.ordinal))
)

function fmtOrdinal(ordinal: string | null | undefined): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}

// ── Constantes ────────────────────────────────────────────────────────────────

const KPIS = [
  { clave: 'total',     label: 'Total indicadores' },
  { clave: 'evaluados', label: 'Evaluados' },
  { clave: 'promedio',  label: 'Promedio general' },
  { clave: 'nivel',     label: 'Nivel general' },
]

const ALTURAS = [
  { valor: 'sm', label: 'Pequeño' },
  { valor: 'md', label: 'Mediano' },
  { valor: 'lg', label: 'Grande' },
]

const ANCHOS = [
  { valor: 'sm', label: 'Pequeño (300 px)' },
  { valor: 'md', label: 'Mediano (420 px)' },
  { valor: 'lg', label: 'Grande (560 px)' },
]

const COLUMNAS_SISTEMA: Record<string, { clave: string; label: string }[]> = {
  TABLA_GENERAL: [
    { clave: 'n_factor',      label: 'N Factor' },
    { clave: 'nombre_factor', label: 'Factor' },
    { clave: 'peso_factor',   label: 'Ponderacion' },
    { clave: 'n_caract',      label: 'N Caract.' },
    { clave: 'nombre_caract', label: 'Caracteristica' },
    { clave: 'aspecto',       label: 'Aspecto' },
    { clave: 'valoracion',    label: 'Valoracion' },
    { clave: 'gradacion',     label: 'Gradacion' },
    { clave: 'pct',           label: 'Pond.' },
    { clave: 'nivel',         label: 'Nivel' },
  ],
  TABLA_SEMAFORO: [
    { clave: 'caract',     label: 'Caracteristica' },
    { clave: 'aspecto',    label: 'Aspecto' },
    { clave: 'valoracion', label: 'Valoracion' },
    { clave: 'fuerte',     label: 'Fuerte' },
    { clave: 'debil',      label: 'Debil' },
    { clave: 'muy_debil',  label: 'Muy debil' },
  ],
  TABLA_ESTRUCTURA: [
    { clave: 'codigo',        label: 'Codigo' },
    { clave: 'tipo',          label: 'Tipo' },
    { clave: 'nombre',        label: 'Nombre' },
    { clave: 'peso',          label: 'Ponderacion' },
    { clave: 'valoracion',    label: 'Valoracion' },
    { clave: 'pct',           label: '%' },
    { clave: 'grado',         label: 'Grado' },
    { clave: 'clasificacion', label: 'Clasificacion' },
  ],
}

const ANCHOS_IMG = [
  { valor: '25%',  label: '25%' },
  { valor: '50%',  label: '50%' },
  { valor: '75%',  label: '75%' },
  { valor: '100%', label: '100%' },
]

const TC_FUENTES = [
  { id: 'factores'        as TcFuente, label: 'Factores' },
  { id: 'caracteristicas' as TcFuente, label: 'Características' },
  { id: 'aspectos'        as TcFuente, label: 'Aspectos' },
]

const TC_COLUMNAS: Record<TcFuente, { clave: string; label: string; default: boolean }[]> = {
  factores: [
    { clave: 'ordinal',      label: 'Ordinal',          default: false },
    { clave: 'nombre',       label: 'Factor',            default: true  },
    { clave: 'calificacion', label: 'Calificación',      default: true  },
    { clave: 'nivel',        label: 'Nivel / Grado',     default: true  },
    { clave: 'peso',         label: 'Peso / Ponderación', default: false },
  ],
  caracteristicas: [
    { clave: 'ordinal',      label: 'Ordinal',           default: false },
    { clave: 'factor',       label: 'Factor',             default: false },
    { clave: 'nombre',       label: 'Característica',     default: true  },
    { clave: 'calificacion', label: 'Calificación',       default: true  },
    { clave: 'nivel',        label: 'Nivel / Grado',      default: true  },
    { clave: 'peso',         label: 'Peso / Ponderación', default: false },
  ],
  aspectos: [
    { clave: 'ordinal',      label: 'Ordinal',           default: false },
    { clave: 'factor',       label: 'Factor',             default: false },
    { clave: 'caract',       label: 'Característica',     default: false },
    { clave: 'nombre',       label: 'Aspecto',            default: true  },
    { clave: 'calificacion', label: 'Calificación',       default: true  },
    { clave: 'grado',        label: 'Nivel / Grado',      default: false },
  ],
}

// Mapa plano para evitar el patron }[key] que confunde el parser Vue SFC
const TIPO_LABELS: Record<string, string> = {
  KPIS_RESUMEN:     'KPIs de resumen',
  TABLA_GENERAL:    'Tabla general',
  TABLA_SEMAFORO:   'Tabla semaforo',
  TABLA_ESTRUCTURA: 'Estructura jerarquica',
  GRAFICOS_TODOS:   'Todos los graficos',
  GRAFICO_FACTOR:   'Grafico por factor',
  COMPARATIVO:      'Comparativo',
  IMAGEN:           'Imagen',
  TABLA_CUSTOM:     'Tabla personalizada',
}

// ── Estado local (draft) ──────────────────────────────────────────────────────

const draft          = ref<Record<string, any>>({})
const nuevoTituloCol = ref('')
const imgFuente      = ref<'url' | 'archivo'>('url')
const fileInputRef   = ref<HTMLInputElement | null>(null)
const tcFuente       = ref<TcFuente | ''>('')
const tcColumnas     = ref<string[]>([])

watch(() => props.visible, (v) => {
  if (v && props.bloque) {
    draft.value = JSON.parse(JSON.stringify(props.bloque.params ?? {}))
    const tipo = props.bloque.tipo
    if (['GRAFICOS_TODOS', 'GRAFICO_FACTOR'].includes(tipo)) {
      if (!draft.value.altura) draft.value.altura = 'md'
      if (!draft.value.ancho)  draft.value.ancho  = 'md'
    }
    if (!draft.value.columnasExtra) draft.value.columnasExtra = []
    if (tipo === 'COMPARATIVO') {
      if (!draft.value.vista) draft.value.vista = 'tabla'
      if (!draft.value.filtroComponentes) draft.value.filtroComponentes = []
    }
    if (tipo === 'IMAGEN') {
      if (!draft.value.ancho) draft.value.ancho = '100%'
      imgFuente.value = (draft.value.url as string | undefined)?.startsWith('data:') ? 'archivo' : 'url'
    }
    if (tipo === 'TABLA_CUSTOM') {
      if (!draft.value.headers) draft.value.headers = ['', '', '']
      if (!draft.value.rows)    draft.value.rows    = [['', '', '']]
      tcFuente.value   = ''
      tcColumnas.value = []
    }
    nuevoTituloCol.value = ''
  }
})

// ── Computeds ─────────────────────────────────────────────────────────────────

const tipoLabel = computed(() => TIPO_LABELS[props.bloque?.tipo ?? ''] ?? props.bloque?.tipo ?? '')

const esTabla = computed(() =>
  ['TABLA_GENERAL', 'TABLA_SEMAFORO', 'TABLA_ESTRUCTURA'].includes(props.bloque?.tipo ?? '')
)

const columnasSistema = computed(() => COLUMNAS_SISTEMA[props.bloque?.tipo ?? ''] ?? [])

const columnasExtra = computed<ExtraColumna[]>(() => draft.value.columnasExtra ?? [])

function recolectarAspectos(nodo: NodoResultado): AspectoResultado[] {
  return [...nodo.aspectos, ...nodo.hijos.flatMap(recolectarAspectos)]
}

const filasExtraDisponibles = computed<{ key: string; label: string }[]>(() => {
  const tipo = props.bloque?.tipo
  const datos = store.resultados
  if (!datos || !tipo) return []

  if (tipo === 'TABLA_GENERAL') {
    return datos.factores.map(f => ({
      key: 'f_' + f.id_componente,
      label: (fmtOrdinal(f.ordinal) ? fmtOrdinal(f.ordinal) + ' ' : '') + f.nombre
    }))
  }

  if (tipo === 'TABLA_SEMAFORO') {
    const rows: { key: string; label: string }[] = []
    for (const f of datos.factores) {
      const caracts = f.hijos.length ? f.hijos : [f]
      for (const c of caracts) {
        for (const a of recolectarAspectos(c)) {
          rows.push({ key: 'a_' + a.id_indicador, label: (a.ordinal ? fmtOrdinal(a.ordinal) + '. ' : '') + a.nombre })
        }
      }
    }
    return rows
  }

  if (tipo === 'TABLA_ESTRUCTURA') {
    const rows: { key: string; label: string }[] = []
    const walk = (n: NodoResultado) => {
      rows.push({ key: 'c_' + n.id_componente, label: (fmtOrdinal(n.ordinal) ? fmtOrdinal(n.ordinal) + ' ' : '') + n.nombre })
      for (const h of n.hijos) walk(h)
    }
    for (const f of datos.factores) walk(f)
    return rows
  }

  return []
})

// ── Operaciones sobre el draft ────────────────────────────────────────────────

function colActiva(clave: string): boolean {
  return !draft.value.columnas || draft.value.columnas.includes(clave)
}

function toggleColumna(clave: string): void {
  const defCols = columnasSistema.value.map(c => c.clave)
  if (!draft.value.columnas) draft.value.columnas = [...defCols]
  const idx: number = draft.value.columnas.indexOf(clave)
  if (idx >= 0) draft.value.columnas.splice(idx, 1)
  else draft.value.columnas.push(clave)
}

function kpiActivo(clave: string): boolean {
  return !draft.value.tarjetas || draft.value.tarjetas.includes(clave)
}

function toggleKpi(clave: string): void {
  if (!draft.value.tarjetas) draft.value.tarjetas = KPIS.map(k => k.clave)
  const idx: number = draft.value.tarjetas.indexOf(clave)
  if (idx >= 0) draft.value.tarjetas.splice(idx, 1)
  else draft.value.tarjetas.push(clave)
}

function factorActivo(id: number): boolean {
  return !draft.value.factoresIds || draft.value.factoresIds.includes(id)
}

function toggleFactor(id: number): void {
  const allIds = factoresStore.value.map(f => f.id_componente)
  if (!draft.value.factoresIds) draft.value.factoresIds = [...allIds]
  const idx: number = draft.value.factoresIds.indexOf(id)
  if (idx >= 0) draft.value.factoresIds.splice(idx, 1)
  else draft.value.factoresIds.push(id)
}

function agregarColumnaExtra(): void {
  const titulo = nuevoTituloCol.value.trim()
  if (!titulo) return
  if (!draft.value.columnasExtra) draft.value.columnasExtra = []
  draft.value.columnasExtra.push({ id: crypto.randomUUID(), titulo, filas: {} })
  nuevoTituloCol.value = ''
}

function eliminarColumnaExtra(id: string): void {
  if (!draft.value.columnasExtra) return
  draft.value.columnasExtra = draft.value.columnasExtra.filter((c: ExtraColumna) => c.id !== id)
}

// ── COMPARATIVO ───────────────────────────────────────────────────────────────

function factorComparativoActivo(id: number): boolean {
  const filtro = draft.value.filtroComponentes as number[] | undefined
  return !filtro?.length || filtro.includes(id)
}

function toggleFactorComparativo(id: number): void {
  const allIds = factoresStore.value.map(f => f.id_componente)
  if (!draft.value.filtroComponentes || !(draft.value.filtroComponentes as number[]).length) {
    draft.value.filtroComponentes = allIds.filter(x => x !== id)
  } else {
    const arr = draft.value.filtroComponentes as number[]
    const idx = arr.indexOf(id)
    if (idx >= 0) arr.splice(idx, 1)
    else arr.push(id)
    if (arr.length === allIds.length) draft.value.filtroComponentes = []
  }
}

// ── TABLA_CUSTOM ──────────────────────────────────────────────────────────────

function agregarColumnaTabla(): void {
  if (!draft.value.headers) draft.value.headers = []
  if (!draft.value.rows)    draft.value.rows    = []
  draft.value.headers.push('')
  for (const row of draft.value.rows as string[][]) row.push('')
}

function eliminarColumnaTabla(ci: number): void {
  if (!draft.value.headers) return
  draft.value.headers.splice(ci, 1)
  if (draft.value.rows) {
    for (const row of draft.value.rows as string[][]) row.splice(ci, 1)
  }
}

function moverColumna(ci: number, dir: -1 | 1): void {
  const headers = draft.value.headers as string[]
  const rows    = draft.value.rows    as string[][]
  const ti = ci + dir
  if (!headers || ti < 0 || ti >= headers.length) return
  ;[headers[ci], headers[ti]] = [headers[ti], headers[ci]]
  for (const row of (rows ?? [])) {
    const tmp = row[ci]; row[ci] = row[ti]; row[ti] = tmp
  }
}

function agregarFilaTabla(): void {
  if (!draft.value.rows) draft.value.rows = []
  const cols = (draft.value.headers as string[] ?? []).length || 1
  ;(draft.value.rows as string[][]).push(new Array(cols).fill(''))
}

function eliminarFilaTabla(ri: number): void {
  if (!draft.value.rows) return
  ;(draft.value.rows as string[][]).splice(ri, 1)
}

// ── IMAGEN ────────────────────────────────────────────────────────────────────

function cargarArchivo(e: Event): void {
  const file = (e.target as HTMLInputElement).files?.[0]
  if (!file) return
  const reader = new FileReader()
  reader.onload = (ev) => { draft.value.url = ev.target?.result as string }
  reader.readAsDataURL(file)
}

// ── TABLA_CUSTOM ──────────────────────────────────────────────────────────────

function seleccionarFuente(id: TcFuente): void {
  if (tcFuente.value === id) {
    tcFuente.value   = ''
    tcColumnas.value = []
    return
  }
  tcFuente.value   = id
  tcColumnas.value = TC_COLUMNAS[id].filter(c => c.default).map(c => c.clave)
}

function toggleTcColumna(clave: string): void {
  const idx = tcColumnas.value.indexOf(clave)
  if (idx >= 0) tcColumnas.value.splice(idx, 1)
  else tcColumnas.value.push(clave)
}

function vaciarTabla(): void {
  draft.value.headers = ['', '', '']
  draft.value.rows    = [['', '', '']]
  tcFuente.value      = ''
  tcColumnas.value    = []
}

function importarDatos(): void {
  const fuente = tcFuente.value as TcFuente
  const cols   = tcColumnas.value
  if (!fuente || !cols.length) return
  const datos = store.resultados
  if (!datos) return

  draft.value.headers = cols.map(c => TC_COLUMNAS[fuente].find(d => d.clave === c)?.label ?? c)

  const rows: string[][] = []

  if (fuente === 'factores') {
    for (const f of datos.factores) {
      rows.push(cols.map(c => {
        if (c === 'ordinal')      return fmtOrdinal(f.ordinal) || '—'
        if (c === 'nombre')       return f.nombre
        if (c === 'calificacion') return f.valoracion != null ? (f.valoracion as number).toFixed(2) : '—'
        if (c === 'nivel')        return f.grado ?? '—'
        if (c === 'peso')         return (f as any).peso != null ? String((f as any).peso) : '—'
        return '—'
      }))
    }
  } else if (fuente === 'caracteristicas') {
    for (const f of datos.factores) {
      const factorLabel = (fmtOrdinal(f.ordinal) ? fmtOrdinal(f.ordinal) + ' ' : '') + f.nombre
      for (const c of (f.hijos.length ? f.hijos : [f])) {
        rows.push(cols.map(col => {
          if (col === 'factor')       return factorLabel
          if (col === 'ordinal')      return fmtOrdinal(c.ordinal) || '—'
          if (col === 'nombre')       return c.nombre
          if (col === 'calificacion') return c.valoracion != null ? (c.valoracion as number).toFixed(2) : '—'
          if (col === 'nivel')        return c.grado ?? '—'
          if (col === 'peso')         return (c as any).peso != null ? String((c as any).peso) : '—'
          return '—'
        }))
      }
    }
  } else if (fuente === 'aspectos') {
    for (const f of datos.factores) {
      const factorLabel = (fmtOrdinal(f.ordinal) ? fmtOrdinal(f.ordinal) + ' ' : '') + f.nombre
      for (const caract of (f.hijos.length ? f.hijos : [f])) {
        const caractLabel = (fmtOrdinal(caract.ordinal) ? fmtOrdinal(caract.ordinal) + ' ' : '') + caract.nombre
        for (const a of recolectarAspectos(caract)) {
          rows.push(cols.map(col => {
            if (col === 'factor')       return factorLabel
            if (col === 'caract')       return caractLabel
            if (col === 'ordinal')      return a.ordinal ?? '—'
            if (col === 'nombre')       return a.nombre
            if (col === 'calificacion') return a.valoracion != null ? a.valoracion.toFixed(2) : '—'
            if (col === 'grado')        return a.grado ?? '—'
            return '—'
          }))
        }
      }
    }
  }

  draft.value.rows = rows
}

function aplicar(): void {
  if (!props.bloque) return
  emit('guardar', { id: props.bloque.id, params: JSON.parse(JSON.stringify(draft.value)) })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible && _ctx.bloque)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h3", null, "Configurar — " + _toDisplayString(tipoLabel.value), 1),
              _createElementVNode("button", {
                class: "btn-cerrar",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cerrar')))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.bloque.tipo === 'KPIS_RESUMEN')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "cfg-desc" }, "Seleccione las tarjetas que desea mostrar.", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(KPIS, (k) => {
                        return _createElementVNode("label", {
                          key: k.clave,
                          class: "check-item"
                        }, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: kpiActivo(k.clave),
                            onChange: ($event: any) => (toggleKpi(k.clave))
                          }, null, 40, _hoisted_6),
                          _createTextVNode(" " + _toDisplayString(k.label), 1)
                        ])
                      }), 64))
                    ])
                  ], 64))
                : (esTabla.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Columnas del sistema", -1)),
                        _createElementVNode("div", _hoisted_8, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnasSistema.value, (c) => {
                            return (_openBlock(), _createElementBlock("label", {
                              key: c.clave,
                              class: "check-item"
                            }, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: colActiva(c.clave),
                                onChange: ($event: any) => (toggleColumna(c.clave))
                              }, null, 40, _hoisted_9),
                              _createTextVNode(" " + _toDisplayString(c.label), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Columnas de texto adicionales", -1)),
                        _createElementVNode("p", _hoisted_11, " Columnas personalizadas con texto libre por " + _toDisplayString(_ctx.bloque.tipo === 'TABLA_GENERAL' ? 'factor' : _ctx.bloque.tipo === 'TABLA_SEMAFORO' ? 'aspecto' : 'componente') + ". ", 1),
                        _createElementVNode("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((nuevoTituloCol).value = $event)),
                            class: "input-col",
                            placeholder: "Nombre de la columna...",
                            onKeyup: _withKeys(agregarColumnaExtra, ["enter"])
                          }, null, 544), [
                            [_vModelText, nuevoTituloCol.value]
                          ]),
                          _createElementVNode("button", {
                            class: "btn-add-col",
                            disabled: !nuevoTituloCol.value.trim(),
                            onClick: agregarColumnaExtra
                          }, " Añadir ", 8, _hoisted_13)
                        ]),
                        (columnasExtra.value.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnasExtra.value, (ec) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: ec.id,
                                  class: "extra-col-bloque"
                                }, [
                                  _createElementVNode("div", _hoisted_15, [
                                    _withDirectives(_createElementVNode("input", {
                                      "onUpdate:modelValue": ($event: any) => ((ec.titulo) = $event),
                                      class: "input-col-titulo",
                                      placeholder: "Nombre de la columna"
                                    }, null, 8, _hoisted_16), [
                                      [_vModelText, ec.titulo]
                                    ]),
                                    _createElementVNode("button", {
                                      class: "btn-elim-col",
                                      onClick: ($event: any) => (eliminarColumnaExtra(ec.id))
                                    }, "✕ Eliminar", 8, _hoisted_17)
                                  ]),
                                  (filasExtraDisponibles.value.length)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filasExtraDisponibles.value, (fila) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: fila.key,
                                            class: "extra-fila"
                                          }, [
                                            _createElementVNode("span", _hoisted_19, _toDisplayString(fila.label), 1),
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": ($event: any) => ((ec.filas[fila.key]) = $event),
                                              class: "input-fila",
                                              placeholder: "Texto..."
                                            }, null, 8, _hoisted_20), [
                                              [_vModelText, ec.filas[fila.key]]
                                            ])
                                          ]))
                                        }), 128))
                                      ]))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_21, "Sin datos disponibles."))
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_22, "Sin columnas adicionales."))
                      ])
                    ], 64))
                  : (_ctx.bloque.tipo === 'GRAFICOS_TODOS')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_23, [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Factores a mostrar", -1)),
                          _createElementVNode("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factoresStore.value, (f) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: f.id_componente,
                                class: "check-item"
                              }, [
                                _createElementVNode("input", {
                                  type: "checkbox",
                                  checked: factorActivo(f.id_componente),
                                  onChange: ($event: any) => (toggleFactor(f.id_componente))
                                }, null, 40, _hoisted_25),
                                _createTextVNode(" " + _toDisplayString(fmtOrdinal(f.ordinal)) + " " + _toDisplayString(f.nombre), 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Altura del gráfico", -1)),
                          _createElementVNode("div", _hoisted_27, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ALTURAS, (a) => {
                              return _createElementVNode("label", {
                                key: a.valor,
                                class: "radio-item"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((draft.value.altura) = $event)),
                                  type: "radio",
                                  value: a.valor
                                }, null, 8, _hoisted_28), [
                                  [_vModelRadio, draft.value.altura]
                                ]),
                                _createTextVNode(" " + _toDisplayString(a.label), 1)
                              ])
                            }), 64))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Ancho de cada tarjeta", -1)),
                          _createElementVNode("div", _hoisted_30, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ANCHOS, (a) => {
                              return _createElementVNode("label", {
                                key: a.valor,
                                class: "radio-item"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((draft.value.ancho) = $event)),
                                  type: "radio",
                                  value: a.valor
                                }, null, 8, _hoisted_31), [
                                  [_vModelRadio, draft.value.ancho]
                                ]),
                                _createTextVNode(" " + _toDisplayString(a.label), 1)
                              ])
                            }), 64))
                          ])
                        ])
                      ], 64))
                    : (_ctx.bloque.tipo === 'GRAFICO_FACTOR')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("div", _hoisted_32, [
                            _cache[23] || (_cache[23] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Altura del gráfico", -1)),
                            _createElementVNode("div", _hoisted_33, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ALTURAS, (a) => {
                                return _createElementVNode("label", {
                                  key: a.valor,
                                  class: "radio-item"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((draft.value.altura) = $event)),
                                    type: "radio",
                                    value: a.valor
                                  }, null, 8, _hoisted_34), [
                                    [_vModelRadio, draft.value.altura]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(a.label), 1)
                                ])
                              }), 64))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _cache[24] || (_cache[24] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Ancho de la tarjeta", -1)),
                            _createElementVNode("div", _hoisted_36, [
                              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ANCHOS, (a) => {
                                return _createElementVNode("label", {
                                  key: a.valor,
                                  class: "radio-item"
                                }, [
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((draft.value.ancho) = $event)),
                                    type: "radio",
                                    value: a.valor
                                  }, null, 8, _hoisted_37), [
                                    [_vModelRadio, draft.value.ancho]
                                  ]),
                                  _createTextVNode(" " + _toDisplayString(a.label), 1)
                                ])
                              }), 64))
                            ])
                          ])
                        ], 64))
                      : (_ctx.bloque.tipo === 'COMPARATIVO')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createElementVNode("div", _hoisted_38, [
                              _cache[27] || (_cache[27] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Vista inicial", -1)),
                              _createElementVNode("div", _hoisted_39, [
                                _createElementVNode("label", _hoisted_40, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((draft.value.vista) = $event)),
                                    value: "tabla"
                                  }, null, 512), [
                                    [_vModelRadio, draft.value.vista]
                                  ]),
                                  _cache[25] || (_cache[25] = _createTextVNode(" Tabla "))
                                ]),
                                _createElementVNode("label", _hoisted_41, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "radio",
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((draft.value.vista) = $event)),
                                    value: "grafico"
                                  }, null, 512), [
                                    [_vModelRadio, draft.value.vista]
                                  ]),
                                  _cache[26] || (_cache[26] = _createTextVNode(" Gráfico "))
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_42, [
                              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Factores a mostrar", -1)),
                              _cache[29] || (_cache[29] = _createElementVNode("p", { class: "cfg-desc" }, "Seleccione los factores que aparecerán en el comparativo. Sin selección se muestran todos.", -1)),
                              _createElementVNode("div", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factoresStore.value, (f) => {
                                  return (_openBlock(), _createElementBlock("label", {
                                    key: f.id_componente,
                                    class: "check-item"
                                  }, [
                                    _createElementVNode("input", {
                                      type: "checkbox",
                                      checked: factorComparativoActivo(f.id_componente),
                                      onChange: ($event: any) => (toggleFactorComparativo(f.id_componente))
                                    }, null, 40, _hoisted_44),
                                    _createTextVNode(" " + _toDisplayString(fmtOrdinal(f.ordinal)) + " " + _toDisplayString(f.nombre), 1)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ], 64))
                        : (_ctx.bloque.tipo === 'IMAGEN')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                              _createElementVNode("div", _hoisted_45, [
                                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Fuente de la imagen", -1)),
                                _createElementVNode("div", _hoisted_46, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["img-tab", { activo: imgFuente.value === 'url' }]),
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (imgFuente.value = 'url'))
                                  }, "URL remota", 2),
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["img-tab", { activo: imgFuente.value === 'archivo' }]),
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (imgFuente.value = 'archivo'))
                                  }, "Desde el equipo", 2)
                                ]),
                                (imgFuente.value === 'url')
                                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                      key: 0,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((draft.value.url) = $event)),
                                      class: "input-full",
                                      placeholder: "https://…",
                                      style: {"margin-top":"8px"}
                                    }, null, 512)), [
                                      [_vModelText, draft.value.url]
                                    ])
                                  : (_openBlock(), _createElementBlock("div", {
                                      key: 1,
                                      class: "archivo-zona",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (fileInputRef.value?.click()))
                                    }, [
                                      _createElementVNode("input", {
                                        ref_key: "fileInputRef",
                                        ref: fileInputRef,
                                        type: "file",
                                        accept: "image/*",
                                        style: {"display":"none"},
                                        onChange: cargarArchivo
                                      }, null, 544),
                                      (draft.value.url && draft.value.url.startsWith('data:'))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, " Imagen cargada — haga clic para cambiar "))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_48, "Haga clic para seleccionar una imagen del equipo"))
                                    ]))
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _cache[31] || (_cache[31] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Texto alternativo", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((draft.value.alt) = $event)),
                                  class: "input-full",
                                  placeholder: "Descripción de la imagen"
                                }, null, 512), [
                                  [_vModelText, draft.value.alt]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_50, [
                                _cache[32] || (_cache[32] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Pie de imagen (opcional)", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((draft.value.titulo) = $event)),
                                  class: "input-full",
                                  placeholder: "Texto bajo la imagen…"
                                }, null, 512), [
                                  [_vModelText, draft.value.titulo]
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _cache[33] || (_cache[33] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Ancho", -1)),
                                _createElementVNode("div", _hoisted_52, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(ANCHOS_IMG, (a) => {
                                    return _createElementVNode("label", {
                                      key: a.valor,
                                      class: "radio-item"
                                    }, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "radio",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((draft.value.ancho) = $event)),
                                        value: a.valor
                                      }, null, 8, _hoisted_53), [
                                        [_vModelRadio, draft.value.ancho]
                                      ]),
                                      _createTextVNode(" " + _toDisplayString(a.label), 1)
                                    ])
                                  }), 64))
                                ])
                              ])
                            ], 64))
                          : (_ctx.bloque.tipo === 'TABLA_CUSTOM')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                _createElementVNode("div", _hoisted_54, [
                                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Título de la tabla", -1)),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((draft.value.titulo) = $event)),
                                    class: "input-full",
                                    placeholder: "Título (opcional)"
                                  }, null, 512), [
                                    [_vModelText, draft.value.titulo]
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Importar datos", -1)),
                                  _cache[36] || (_cache[36] = _createElementVNode("p", { class: "cfg-desc" }, "Seleccione la fuente y las columnas que desea cargar.", -1)),
                                  _createElementVNode("div", _hoisted_56, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TC_FUENTES, (opt) => {
                                      return _createElementVNode("button", {
                                        key: opt.id,
                                        class: _normalizeClass(["btn-import", { activo: tcFuente.value === opt.id }]),
                                        onClick: ($event: any) => (seleccionarFuente(opt.id))
                                      }, _toDisplayString(opt.label), 11, _hoisted_57)
                                    }), 64)),
                                    _createElementVNode("button", {
                                      class: "btn-import btn-import--elim",
                                      onClick: vaciarTabla
                                    }, "Vaciar tabla")
                                  ]),
                                  (tcFuente.value)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createElementVNode("div", _hoisted_58, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(TC_COLUMNAS[tcFuente.value], (col) => {
                                            return (_openBlock(), _createElementBlock("label", {
                                              key: col.clave,
                                              class: "check-item"
                                            }, [
                                              _createElementVNode("input", {
                                                type: "checkbox",
                                                checked: tcColumnas.value.includes(col.clave),
                                                onChange: ($event: any) => (toggleTcColumna(col.clave))
                                              }, null, 40, _hoisted_59),
                                              _createTextVNode(" " + _toDisplayString(col.label), 1)
                                            ]))
                                          }), 128))
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn-add-col",
                                          disabled: !tcColumnas.value.length,
                                          onClick: importarDatos
                                        }, " Importar / Reemplazar tabla ", 8, _hoisted_60)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_61, [
                                  _cache[37] || (_cache[37] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Encabezados de columna", -1)),
                                  _createElementVNode("div", _hoisted_62, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((draft.value.headers ?? []), (h, ci) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: ci,
                                        class: "tabla-header-cell"
                                      }, [
                                        _createElementVNode("div", _hoisted_63, [
                                          _createElementVNode("button", {
                                            class: "btn-reorder",
                                            disabled: ci === 0,
                                            onClick: ($event: any) => (moverColumna(ci, -1))
                                          }, "←", 8, _hoisted_64),
                                          _createElementVNode("button", {
                                            class: "btn-reorder",
                                            disabled: ci === (draft.value.headers?.length ?? 0) - 1,
                                            onClick: ($event: any) => (moverColumna(ci, 1))
                                          }, "→", 8, _hoisted_65)
                                        ]),
                                        _withDirectives(_createElementVNode("input", {
                                          "onUpdate:modelValue": ($event: any) => ((draft.value.headers[ci]) = $event),
                                          class: "input-fila",
                                          placeholder: "Columna"
                                        }, null, 8, _hoisted_66), [
                                          [_vModelText, draft.value.headers[ci]]
                                        ]),
                                        _createElementVNode("button", {
                                          class: "btn-elim-mini",
                                          onClick: ($event: any) => (eliminarColumnaTabla(ci))
                                        }, "✕", 8, _hoisted_67)
                                      ]))
                                    }), 128)),
                                    _createElementVNode("button", {
                                      class: "btn-add-col",
                                      onClick: agregarColumnaTabla
                                    }, "+ Col")
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_68, [
                                  _cache[38] || (_cache[38] = _createElementVNode("div", { class: "cfg-seccion-titulo" }, "Filas", -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((draft.value.rows ?? []), (row, ri) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: ri,
                                      class: "tabla-fila-row"
                                    }, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (cell, ci) => {
                                        return _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                          key: ci,
                                          "onUpdate:modelValue": ($event: any) => ((draft.value.rows[ri][ci]) = $event),
                                          class: "input-fila-area",
                                          rows: "1",
                                          placeholder: "…"
                                        }, null, 8, _hoisted_69)), [
                                          [_vModelText, draft.value.rows[ri][ci]]
                                        ])
                                      }), 128)),
                                      _createElementVNode("button", {
                                        class: "btn-elim-mini",
                                        onClick: ($event: any) => (eliminarFilaTabla(ri))
                                      }, "✕", 8, _hoisted_70)
                                    ]))
                                  }), 128)),
                                  _createElementVNode("button", {
                                    class: "btn-add-col",
                                    style: {"margin-top":"0.5rem"},
                                    onClick: agregarFilaTabla
                                  }, "+ Fila")
                                ])
                              ], 64))
                            : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: _cache[16] || (_cache[16] = ($event: any) => (emit('cerrar')))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn guardar",
                onClick: aplicar
              }, "Aplicar")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})